<template lang="pug">
v-main
  
  v-container
    v-dialog(v-model='dialogUniqueFullname' max-width='400')
      v-card
        v-card-title.text-h5
          p(style="margin:auto") Confirm
        v-card-text(style="margin-bottom:0.5rem")
          p(style="margin:auto; font-size:18px; text-align:center") User with current name is already Exist, Are you sure want to continue ?
        v-card-actions()
          v-spacer
          div(style="display:flex; width:100%")
            v-btn(style="color:#000; flex:1;margin:.3rem" text='' @click='dialogUniqueFullname = false')
              | No
            v-btn(v-if='createType=="super"' style="background:#1976D2;color:#fff; flex:1;margin:.3rem" text='' @click='createSuperAdmin(); dialogUniqueFullname = false')
              | Yes
            v-btn(v-else style="background:#1976D2;color:#fff; flex:1;margin:.3rem" text='' @click='create(); dialogUniqueFullname = false')
              | Yes
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title Create Admin Business Unit
      v-divider
      v-card-text
        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(color="black") 
              span(style="color: #D42A2A;") *
              | &nbsp;Name&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="users.full_name",
              label="Name",
              :rules="[rules.required]",
              @keyup="sendVal(users)",
              @keypress="isLetter($event)"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              span(style="color: #D42A2A;") *
              | &nbsp;Email&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
            small(style="color: #F08703;" class="ml-4") *Email account credential login
          v-col(cols="5")
            v-text-field(
              v-model="users.email",
              label="Email (Don't use personal e-mail)"
              type="email",
              :rules="[rules.required, rules.email]",
              @keyup="sendVal(users)"
            )

        //- v-row(no-gutters)
        //-   v-col(cols="4") 
        //-     v-subheader Phone Number
        //-   v-col(cols="5")
        //-     v-text-field(
        //-       maxlength = "14"
        //-       v-model="users.msisdn",
        //-       label="Phone Number",
        //-       :rules="[rules.required, rules.number, rules.msisdn]",
        //-       @keyup="sendVal(users)",
        //-       @keypress="isNumber($event)"
        //-     )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Super Admin&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-radio-group(v-model="users.is_super_admin", row)
              v-radio(label="Yes", value="yes")
              v-radio(label="No", value="no")

        v-row(no-gutters, v-if="users.is_super_admin == 'no'")
          v-col(cols="4") 
            v-subheader(color="black") 
              span(style="color: #D42A2A;") *
              | &nbsp;Alias Name&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="bu.alias",
              label="Alias",
              :rules="[rules.required]",
              @keypress="isLetter($event)"
            )

        v-row(no-gutters, v-if="users.is_super_admin == 'no'")
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              span(style="color: #D42A2A;") *
              | &nbsp;Business Unit Email&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
            small(style="color: #F08703;" class="ml-4") *Email for notification memo
          v-col(cols="5")
            v-text-field(
              v-model="bu.email",
              label="Email (Don't use personal e-mail)",
              type="email",
              :rules="[rules.required, rules.email]"
            )
        v-row( style="padding-top:1rem; padding-bottom:1rem" no-gutters, v-if="users.is_super_admin == 'no'")
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              | &nbsp;Business Unit Phone Number&nbsp;
              span(style="font-size:.7rem; color: #909090") (Optional)
            small(style="color: #F08703;" class="ml-4") *Phone number for notification memo
          v-col(cols="5")
            vue-tel-input(
              @validate="telValidate"
              v-model="bu.msisdn"
              style="border-top: none; box-shadow: none; border-right: none; border-left: none; border-bottom: 2px solid;"
            )
            p(style="color: #ff5252; margin: 0; font-size: 12px;" v-if="bu.msisdn.length > 0 && !validNumber") invalid Phone Number Format

        v-row(no-gutters, v-if="users.is_super_admin == 'no'")
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Position&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="bu.position",
              label="Position",
              :rules="[rules.required]"
            )

        v-row(no-gutters, v-if="users.is_super_admin == 'no'")
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Business Unit&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-autocomplete(
              ref="bisnis_unit",
              v-model="bu.bisnis_unit",
              :rules="[() => !!bu.bisnis_unit || 'This field is required.']",
              :items="bisnis_units",
              item-text="name",
              item-value="id",
              label="Business Unit",
              placeholder="Select"
            )

        v-card-actions.my-8
          v-btn.custom__padding-btn(@click="$router.push('/users')") Back

          v-btn.custom__padding-btn(
            v-if="users.is_super_admin == 'yes' || users.is_super_admin == true",
            color="blue-secondary",
            :disabled="!formSuperAdminIsValid",
            @click="confirmCreate('super'); createType = 'super'"
          ) Create

          v-btn.custom__padding-btn(
            v-if="users.is_super_admin == 'no'",
            color="blue-secondary",
            :disabled="!formIsValid",
            @click="confirmCreate('default'); createType = 'default'"
          ) Create

          v-btn.custom__padding-btn(
            v-if="users.is_super_admin == ''",
            disabled
          ) Create

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data: () => ({
    createType: null,
    dialogUniqueFullname: false,
    validNumber: false,
    users: {
      full_name: "",
      email: "",
      msisdn: null,
      is_super_admin: "",
    },
    bu: {
      alias: "",
      email: "",
      msisdn: "",
      position: "",
      bisnis_unit: "",
      is_active: true,
      is_admin: true,
    },
    bisnis_units: [],
    rules: {
      required: (value) => !!value || "This field is required.",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid email format";
      },
      number: (v) => /[0-9\s]/.test(v) || "Must start 08 or 62",
      msisdn: (value) =>
        (value && value.length >= 10) || "Mobile number cannot be less than 10",
    },
    overlay: false,
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    
    formSuperAdminIsValid() {
      return (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.users.email) &&
        this.users.full_name &&
        this.users.email &&
        //- this.users.msisdn.length >= 10 &&
        this.users.is_super_admin
      );
    },
    formIsValid() {
      return (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.users.email) &&
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.bu.email) &&
        this.users.full_name &&
        this.users.email &&
        //- this.users.msisdn.length >= 10 &&
        this.users.is_super_admin &&
        this.bu.alias &&
        this.bu.email &&
        (this.validNumber || this.bu.msisdn.length == 0) &&
        this.bu.position &&
        this.bu.bisnis_unit
      );
    },
  },
  mounted() {
    this.getBisnisUnit();
  },
  methods: {
    telValidate(telnumber) {
      if (telnumber.valid || this.bu.msisdn.length == 0) {
        this.validNumber = true
      } else {
        this.validNumber = false
      }
    },
    async confirmCreate(param) {
      let token = localStorage.getItem('token');
      const isFullnameUnique = await axios.get(process.env.VUE_APP_API+`/users/findByFullname?fullname=${this.users.full_name}`, {
        headers: { 
          Authorization: `Bearer ${token}`
        }
      })

      if (isFullnameUnique.data.data == null && param == 'super') return this.createSuperAdmin()
      else if (isFullnameUnique.data.data == null && param != 'super') return this.create()
      else this.dialogUniqueFullname = true
    },
    create() {
      this.overlay = true;
      this.users.is_super_admin =
      this.users.is_super_admin == "no" ? false : true;
      this.$store
        .dispatch("createDataUsers", { users: this.users, bu: this.bu })
        .then((res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          this.$toasted.success("Success, account added successfully", {
            icon: "check_circle",
          });
          return this.$router.push("/users");
        })
        .catch((err) => {
          this.overlay = false;
          if (typeof err == 'string') this.$toasted.error(err, { icon: "error" });
          else this.$toasted.error(err.response.data.message, { icon: "error" });
        });
    },
    createSuperAdmin() {
      this.overlay = true;
      this.users.is_super_admin =
        this.users.is_super_admin == "no" ? false : true;

      this.$store
        .dispatch("createDataSuperAdmin", { users: this.users })
        .then((res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          this.$toasted.success("Success, account added successfully", {
            icon: "check_circle",
          });
          return this.$router.push("/users");
        })
        .catch((err) => {
          this.overlay = false;
          if (typeof err == 'string') this.$toasted.error(err, { icon: "error" });	
          else this.$toasted.error(err.response.data.message, { icon: "error" });
        });
    },
    getBisnisUnit() {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/business-unit/list/active`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          let dataBU = res.data.data;
          for (const item of dataBU) {
            this.bisnis_units.push({
              name :item.name,
              id :item._id
            });
          }
        })
        .catch((err) => {
        })
        .finally(() => (this.loading = false));
    },
    sendVal(item) {
      this.bu.alias = item.full_name;
      this.bu.email = item.email;
      //- this.bu.msisdn = item.msisdn;
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9 ]+$/.test(char)) return true;
      else e.preventDefault();
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.v-toolbar__content {
  box-shadow: none;
}
</style>